// XXX: reorganize this (with parts/index.js)
// load module chunks
import { size } from 'ldash';
let loader = null // a registered callable
;
let is_ready = null;
export const registerLoader = (loader_f, is_ready_f)=>{
    loader = loader_f;
    is_ready = is_ready_f;
};
let loaded = false;
export const load = ()=>{
    if (loader && !loaded) {
        loader();
        loaded = true;
    }
};
export const isReady = ()=>!is_ready || is_ready();
